<h1 mat-dialog-title style="text-align: center;"><b>{{ data.title }}</b></h1>
<div mat-dialog-content  style="text-align: center;">    
  <p style="margin-bottom: 2rem;white-space:pre-wrap;">{{ data.message }}</p>
</div>
<div mat-dialog-actions align="end" style="justify-content:center;">
  <button mat-button class="selectionButton saveButton" (click)="OnClick()">OK</button>
</div>